import axios from 'axios';

export type SubscriptionsResponse = {
  subscriptions: SubscriptionResponse[];
};

export type SubscriptionResponse = {
  id: string;
  active: boolean;
  customerId: string;
  cityName: string;
  cityId: string;
  restaurantId: string;
  restaurantName: string;
  position: string;
};

export type RestaurantKPIResponse = {
  totalNbEvents: number;
  showRestaurantPage: number;
  showPartnerPopup: number;
  showPartnerSearchRestaurantPage: number;
  showPartnerSimilarRestaurantPage: number;
  clickPartnerPopup: number;
  clickPartnerSearchRestaurantPage: number;
  clickPartnerSimilarRestaurantPage: number;
  clickAllReviews: number;
  clickPhone: number;
  clickCertificate: number;
  clickUberEats: number;
  clickJustEat: number;
  clickDeliveroo: number;
  clickLinkWebsite: number;
  clickGoogleMaps: number;
};

export type RestaurantPeriodStatsResponse = RestaurantPeriodStatResponse[];

export type RestaurantPeriodStatResponse = {
  date: string;
  showRestaurantPage: number;
  showPartnerPopup: number;
  showPartnerSearchRestaurantPage: number;
  showPartnerSimilarRestaurantPage: number;
  clickPartnerPopup: number;
  clickPartnerSearchRestaurantPage: number;
  clickPartnerSimilarRestaurantPage: number;
  clickAllReviews: number;
  clickPhone: number;
  clickCertificate: number;
  clickUberEats: number;
  clickJustEat: number;
  clickDeliveroo: number;
  clickLinkWebsite: number;
  clickGoogleMaps: number;
};

export const fetchSubscriptionsRestaurantRequest = async (restaurantId: string): Promise<SubscriptionsResponse> => {
  const { data } = await axios.post<SubscriptionsResponse>(`/protected/stripe/subscription/${restaurantId}`);
  return data;
};

export const fetchStripePortalSessionRequest = async (customerId: string): Promise<{ url: string }> => {
  const { data } = await axios.post<{ url: string }>(`/protected/stripe/portal/${customerId}`);
  return data;
};

export const fetchKPIRestaurantRequest = async (restaurantId: string, startDate: string, endDate: string): Promise<RestaurantKPIResponse> => {
  const { data } = await axios.get<RestaurantKPIResponse>(`/protected/restaurant/${restaurantId}/global-stats?startDate=${startDate}&endDate=${endDate}`);
  return data;
};

export const fetchPeriodStatsRestaurantRequest = async (restaurantId: string, startDate: string, endDate: string): Promise<RestaurantPeriodStatsResponse> => {
  const { data } = await axios.get<RestaurantPeriodStatsResponse>(
    `/protected/restaurant/${restaurantId}/period-stats?startDate=${startDate}&endDate=${endDate}`
  );
  return data;
};

export const fetchStripeCheckoutSessionRequest = async (restaurantId: string, cityId: string): Promise<{ clientSecret: string }> => {
  const { data } = await axios.post<{ clientSecret: string }>(`/protected/v2/stripe/checkout`, {
    restaurantId,
    cityId
  });
  return data;
};
